import React from 'react'
import cx from 'classnames'

import styles from './Content.module.scss'

export const Content = ({ children, className }) => (
  <div className={cx(styles.content, { [className]: Boolean(className) })}>
    {children}
  </div>
)
